import { useContext } from 'react';
import { useSelector } from 'react-redux';

import BaseOrderSummary from '@r1-frontend/ui-react/organisms/OrderSummary';

import { FullBuyContext, TFullBuyContextProperties } from '~/src/features/full-buy/analytics/context';
import getSummaryInfo from '~/src/features/full-buy/store/selectors/getSummaryInfo';

const OrderSummary = ({ withoutTitle = false }): JSX.Element => {
    const { isVillage, analytics } = useContext<TFullBuyContextProperties>(FullBuyContext);
    const clickViewConnectionCostPopup = analytics.summary.clickViewConnectionCostPopup.bind(analytics.summary);
    const { fullSummaryData } = useSelector(getSummaryInfo(isVillage, clickViewConnectionCostPopup));


    return <BaseOrderSummary
        gapSize={'small'}
        title={withoutTitle ? undefined : 'Ваша заявка'}
        items={fullSummaryData.items}
    />;
};

export default OrderSummary;
